import { apiGet, apiPost } from './client.js';

export interface TransferListRow {
  id: string;
  fromStoreId: string;
  toStoreId: string;
  fromStoreName: string | null;
  toStoreName: string | null;
  status: string;
  lineCount: number;
  createdAt: string;
}

export interface TransferDetail {
  id: string;
  fromStoreId: string;
  toStoreId: string;
  fromStoreName: string | null;
  toStoreName: string | null;
  status: string;
  notes: string | null;
  createdAt: string;
  shippedAt: string | null;
  receivedAt: string | null;
  lines: Array<{
    id: string;
    itemId: string;
    itemName: string;
    serialId: string | null;
    qtyRequested: number;
    qtyShipped: number | null;
    qtyReceived: number | null;
  }>;
}

export function listTransfers() {
  return apiGet<TransferListRow[]>('/api/v1/inventory/transfers').then((r) => r.data);
}

export function getTransfer(id: string) {
  return apiGet<TransferDetail>(`/api/v1/inventory/transfers/${id}`).then((r) => r.data);
}

export function createTransfer(body: {
  toStoreId: string;
  notes?: string;
  lines: Array<{ itemId: string; qtyRequested: number; serialId?: string }>;
}) {
  return apiPost<{ id: string; status: string }, typeof body>('/api/v1/inventory/transfers', body).then(
    (r) => r.data,
  );
}

export function approveTransfer(id: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/transfers/${id}/approve`, {}).then(
    (r) => r.data,
  );
}

export function rejectTransfer(id: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/transfers/${id}/reject`, {}).then(
    (r) => r.data,
  );
}

export function shipTransfer(id: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/transfers/${id}/ship`, {}).then(
    (r) => r.data,
  );
}

export function receiveTransfer(id: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/transfers/${id}/receive`, {}).then(
    (r) => r.data,
  );
}
